export default __webpack_public_path__ + "static/Aliza-988a37212522387bdd1cd100281a538f648e3c918f543d1f2f663e80bb9e8bf4.svg";